import { differenceInDays as e } from "date-fns";
//#region src/date-picker/date-range-picker/utils/apply-max-interval.ts
var t = (t, n, r) => t && n && e(n, t) > r ? [/* @__PURE__ */ new Date(n.getTime() - r * 24 * 60 * 60 * 1e3), n] : [t, n];
//#endregion
export { t as applyMaxInterval };
